import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AddStaticContentEvent, AddVideoEvent, All, LoadStaticContentEvents, RemoveStaticContentEvent, RemoveVideoEvent, UpdateStaticContentEvent } from '../../actions/event'
import { ReplyApi, StaticContentEventApi } from '../../apis'
import { Event } from '../../models'
import { AppState } from '../../reducers'
import { EventService } from './base'

@Injectable()
export class StaticContentEventService extends EventService{
  protected LoadEvents(resourceId: number, events: Event[]): All {
    return new LoadStaticContentEvents(resourceId, events)
  }
  protected AddEvent(event: Event, enabledChatgpt?:boolean): All {
    return new AddStaticContentEvent(event, enabledChatgpt)
  }
  protected RemoveEvent(eventId: number): All {
    return new RemoveStaticContentEvent(eventId)
  }
  protected UpdateEvent(event: Event): All {
    return new UpdateStaticContentEvent(event)
  }
  constructor(protected api: StaticContentEventApi, protected replyApi: ReplyApi, protected store: Store<AppState>) {
    super(api, replyApi, store)
  }
}



// WEBPACK FOOTER //
// ./src/services/event/static-content.ts